import tw from 'twin.macro';

export const dateModifiersStyles = {
  isBetween: tw`bg-brand-moderate bg-opacity-30 rounded-none`,
  selected: tw`bg-brand-intense outline-none`,
  start: tw`bg-brand-intense rounded-l rounded-r-none outline-none`,
  end: tw`bg-brand-intense rounded-r rounded-l-none outline-none`,
  disabled: tw`text-neutral-supershy`,
};
